module.exports = __webpack_public_path__ + "static/media/interreg-ns-co-funded-by-the-eu-horizontal.ccdfccb3.svg";